import { Link } from 'react-router-dom'
import { ASSISTANT_SERVICES, ICON_HEIGHT } from './services'
import './AssistantPage.css'

/**
 * Хаб инструментов: карточки сервисов по макету.
 * Состав раздела задаётся в `services.ts` — вёрстка от него не зависит.
 */
const AssistantPage = () => (
  <div className="assistant-page">
    <div className="assistant-body">
      <h1 className="assistant-title">Помощник</h1>
      <p className="assistant-subtitle">
        Инструменты, которые помогают в работе. Со временем их станет больше.
      </p>

      <ul className="assistant-list">
        {ASSISTANT_SERVICES.map(service => (
          <li key={service.id}>
            <Link
              to={service.path}
              className="assistant-card"
              style={{ background: service.color }}
            >
              <span
                className="assistant-card__icon"
                style={{
                  width: service.iconWidth,
                  height: ICON_HEIGHT,
                  // Кавычки обязательны: Vite инлайнит SVG в data-URI с
                  // апострофами внутри, без них url-токен невалиден и WebKit
                  // отбрасывает маску.
                  maskImage: `url("${service.icon}")`,
                  WebkitMaskImage: `url("${service.icon}")`,
                }}
                aria-hidden
              />
              <span className="assistant-card__text">
                <span className="assistant-card__title">{service.title}</span>
                <span className="assistant-card__description">
                  {service.description}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </div>
)

export default AssistantPage
